import { render, staticRenderFns } from "./QuestionReport.QuestionComparison.vue?vue&type=template&id=ce024adc&scoped=true&"
import script from "./QuestionReport.QuestionComparison.vue?vue&type=script&lang=js&"
export * from "./QuestionReport.QuestionComparison.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReport.QuestionComparison.vue?vue&type=style&index=0&id=ce024adc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce024adc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
